import * as satellite from "satellite.js";
import { normalizeTleExponents } from "./normalizeTleExponents";
import { parseTleLines } from "./parseTleLines";

export function getCurrentPositionFromTLE(tle: string) {
  const tleLines = parseTleLines(tle);
  if (!tleLines) return null;

  try {
    const satrec = satellite.twoline2satrec(normalizeTleExponents(tleLines[0]), tleLines[1]);
    const now = new Date();
    const gmst = satellite.gstime(now);
    const positionAndVelocity = satellite.propagate(satrec, now);

    if (!positionAndVelocity || !positionAndVelocity.position) return null;

    const positionGd = satellite.eciToGeodetic(
      positionAndVelocity.position,
      gmst
    );

    const longitude = satellite.degreesLong(positionGd.longitude);
    const latitude = satellite.degreesLat(positionGd.latitude);
    const altitude = positionGd.height;

    return { lat: latitude, lng: longitude, alt: altitude };
  } catch (err) {
    console.warn("TLE propagation error:", err);
    return null;
  }
}
